import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal, { hideModal, showModal } from '../../widgets/modal'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Alert } from '@/components/ui/alert'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import { actions } from '../Customers/customers.slice'
import { selectFfls } from '../Customers/customers.selectors'
import BusyIndicator, { REGIONS } from '../../widgets/busyIndicator'
import { isEmpty, truncate } from 'lodash'
import Icons from '../../assets/icons'
import Images from '../../assets/images'
import InputMask from 'react-input-mask'
import { getFormattedDateForVarianceData } from '../../widgets/CustomDateRangePicker/CustomDateRangePicker.utils'
import { getFormattedTitle } from '../Reports/reports.constants'
import { SELECT_NONE } from '@/components/ui/select-sentinels'
import Form from '@/components/forms/legacy-form-shim'

const Image = (props) => <img {...props} alt={props.alt || ''} />
const Row = ({ children }) => <div className='flex flex-wrap gap-4 mb-3'>{children}</div>
const Col = ({ md, children }) => {
    const widthClass = md === 12 ? 'w-full' : md === 6 ? 'flex-1 min-w-0' : 'w-full'
    return <div className={widthClass}>{children}</div>
}

const { setSelectedCustomerModal } = actions
const emptyString = ''
const timeOutForAlertPrompt = 5000
const FIRST_INDEX = 0
const SECOND_INDEX = 1
const MAX_STORE_NAME_LENGTH = 30

const VarianceDataModal = () => {
	const dispatch = useDispatch()
	const ffls = useSelector(selectFfls)
	const [storesToDisplay, setStoresToDisplay] = useState()
	const [currentStore, setCurrentStore] = useState()
	const [searchedVaue, setSearchedvalue] = useState(emptyString)

	const resetModal = () => {
		dispatch(setSelectedCustomerModal(null))
	}

	useEffect(() => {
		if (ffls && ffls[FIRST_INDEX]) {
			setStoresToDisplay(ffls)
			setCurrentStore(ffls[FIRST_INDEX])
		}
	}, [ffls])

	const getFormattedName = (varianceName, index) =>
		(varianceName &&
			(index
				? varianceName.substr(FIRST_INDEX, varianceName.indexOf(' '))
				: varianceName.substr(varianceName.indexOf(' ') + SECOND_INDEX))) ||
		emptyString

	const varianceData = {
		firstName:
			currentStore &&
			currentStore.varianceName &&
			(currentStore.varianceName.indexOf(' ') > 0
				? getFormattedName(currentStore.varianceName, 'FIRST_INDEX')
				: currentStore.varianceName),
		lastName:
			currentStore &&
			currentStore.varianceName &&
			(currentStore.varianceName.indexOf(' ') > 0
				? getFormattedName(currentStore.varianceName)
				: ''),
		businessPhone:
			(currentStore &&
				currentStore.phone &&
				currentStore.phone.replace(/\D/g, '')) ||
			emptyString,
		email: (currentStore && currentStore.email) || emptyString,
		expirationDate:
			(currentStore && currentStore.expirationDate) || emptyString,
		fflNumber: (currentStore && currentStore.fflNumber) || emptyString,
		id: (currentStore && currentStore.id) || emptyString,
		loaExpirationDate:
			(currentStore && currentStore.loaExpirationDate) || emptyString,
		loaIssueDate: (currentStore && currentStore.loaIssueDate) || emptyString,
		mailingStreet: (currentStore && currentStore.mailingStreet) || emptyString,
		mailingCity: (currentStore && currentStore.mailingCity) || emptyString,
		mailingState: (currentStore && currentStore.mailingState) || emptyString,
		mailingZipCode:
			(currentStore && currentStore.mailingZipCode) || emptyString,
		premiseStreet: (currentStore && currentStore.premiseStreet) || emptyString,
		premiseCity: (currentStore && currentStore.premiseCity) || emptyString,
		premiseState: (currentStore && currentStore.premiseState) || emptyString,
		premiseZipCode:
			(currentStore && currentStore.premiseZipCode) || emptyString,
		tradeName: (currentStore && currentStore.tradeName) || emptyString,
	}

	const {
		firstName,
		lastName,
		businessPhone,
		email,
		expirationDate,
		loaExpirationDate,
		loaIssueDate,
		tradeName,
		premiseStreet,
		premiseState,
		premiseCity,
		premiseZipCode,
		mailingStreet,
		mailingCity,
		mailingState,
		mailingZipCode,
		fflNumber,
	} = varianceData

	const handleClose = () => {
		dispatch(hideModal())
		resetModal()
	}

	useEffect(() => {
		dispatch(showModal())
	})

	const handleChangeFfl = (id) => {
		setSearchedvalue(emptyString)
		setStoresToDisplay(ffls)
		const store = ffls.find((each) => each.id === id)
		if (store) setCurrentStore(store)
	}

    const footer = (
        <div className='flex justify-end'>
            <Button variant='outline' onClick={resetModal}>
                Close
            </Button>
        </div>
    )

	const [copiedField, setCopiedField] = useState()

	const getField = (props) => (
		<div
			className={
				props.value ? 'code-section h-40' : 'code-section h-40 disabled'
			}
		>
			<pre>
				{props.shouldTrim && props.value && props.value.length >= 35
					? truncate(props.value, {
							length: 35,
							ommission: '...',
						})
					: props.value}
			</pre>
			{props.value && (
				<CopyToClipboard
					text={props.value}
					onCopy={() => {
						setCopiedField(props.key)
						setTimeout(() => {
							setCopiedField(emptyString)
						}, timeOutForAlertPrompt)
					}}
				>
					<span className={props.value ? 'pointer' : 'pe-none'}>
						{copiedField !== props.key ? (
							<Image
								width='23'
								height='23'
								src={Icons.Right}
								className='mt-1 mb-1 mr-2'
							/>
						) : (
							<>
								<Image
									width='23'
									height='23'
									src={Images.checkMarkIcon}
									className='mt-1 mb-1 mr-2'
								/>
							</>
						)}
					</span>
				</CopyToClipboard>
			)}
		</div>
	)

	const selectedStore = () =>
		currentStore && (currentStore.friendlyFFLName || currentStore.legalFFLName)

	const onTextChanged = (e) => {
		const value = e.target.value
		setSearchedvalue(value)
		if (value) {
			const filteredStores = ffls.filter(
				(each) =>
					each.friendlyFFLName &&
					each.friendlyFFLName.toLowerCase().includes(value.toLowerCase())
			)
			setStoresToDisplay(filteredStores)
		} else setStoresToDisplay(ffls)
	}

	const getFormattedStoreName = (storeName) =>
		truncate(storeName, {
			length: MAX_STORE_NAME_LENGTH,
			ommission: '...',
		})

	return (
		<Modal
			reset={handleClose}
			onCancel={resetModal}
			footer={footer}
			title='FFL Data'
			size='md'
		>
			<BusyIndicator region={REGIONS.FETCH_VARIANCE_DATA}>
				{isEmpty(ffls) ? (
					<div>No FFL data found.</div>
				) : (
					<>
                        {copiedField && (
                            <Alert className='mb-30 border border-green-300 text-green-700 bg-green-50'>
                                {copiedField} copied.
                            </Alert>
                        )}
                        <div className='f-14'>
                            <>
                                <div className='border-bottom mb-4 pb-3'>
                                    <div className='mb--15'>
                                        <div className={'form-group'}>
                                            <Label> Select FFL </Label>
                                            <div className='flex gap-2 mb-2'>
                                                <Input
                                                    autoFocus
                                                    name='search-ffl'
                                                    className='search-input'
                                                    placeholder='Search...'
                                                    autoComplete='off'
                                                    value={searchedVaue}
                                                    onChange={onTextChanged}
                                                />
                                            </div>
                                            <Select
                                                value={currentStore?.id ?? ''}
                                                onValueChange={(val) => handleChangeFfl(val)}
                                            >
                                                <SelectTrigger className='w-full' title={getFormattedTitle(selectedStore())}>
                                                    <SelectValue placeholder='Select FFL'>
                                                        {getFormattedStoreName(selectedStore())}
                                                    </SelectValue>
                                                </SelectTrigger>
                                                <SelectContent>
                                                    {isEmpty(storesToDisplay) && (
                                                        <SelectItem value={SELECT_NONE} disabled>No Options</SelectItem>
                                                    )}
                                                    {storesToDisplay &&
                                                        storesToDisplay.map((store) => (
                                                            <SelectItem key={store.id} value={store.id} title={getFormattedTitle(store.friendlyFFLName || store.legalFFLName)}>
                                                                {getFormattedStoreName(store.friendlyFFLName || store.legalFFLName)}
                                                            </SelectItem>
                                                        ))}
                                                </SelectContent>
                                            </Select>
                                        </div>
                                    </div>
                                </div>
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-3'>
                                    <div>
                                        <div className={'form-group'}>
                                            <Label className='f-14'>First Name</Label>
                                            {getField({
                                                key: 'First Name',
                                                value: firstName,
                                                shouldTrim: true,
                                            })}
                                        </div>
                                    </div>
                                    <div>
                                        <div className={'form-group'}>
                                            <Label className='f-14'>Last Name</Label>
                                            {getField({
                                                key: 'Last Name',
                                                value: lastName,
                                                shouldTrim: true,
                                            })}
                                        </div>
                                    </div>
                                    <div>
                                        <div className={'form-group'}>
                                            <Label className='f-14'>FFL Number</Label>
                                            {getField({
                                                key: 'FFL Number',
                                                value: fflNumber,
                                                shouldTrim: true,
                                            })}
                                        </div>
                                    </div>
                                    <div>
                                        <div className={'form-group'}>
                                            <Label className='f-14'>Email</Label>
                                            {getField({
                                                key: 'Email',
                                                value: email,
                                                shouldTrim: true,
                                            })}
                                        </div>
                                    </div>
                                </div>
                                <div className='grid grid-cols-1 md:grid-cols-2 gap-4 mb-3'>
                                    <div>
                                        <div className={'form-group'}>
                                            <Label className='f-14'>
                                                Business Phone Number
                                            </Label>
                                            <div
                                                className={
                                                    businessPhone
                                                        ? 'code-section h-40'
                                                        : 'code-section h-40 disabled'
                                                }
                                            >
                                                <InputMask
                                                    className={
                                                        businessPhone
                                                            ? 'border-0 pointer-none'
                                                            : 'border-0 pointer-none bg-aliceblue'
                                                    }
                                                    name='businessPhone'
                                                    mask='(999)999-9999'
                                                    disableunderline='true'
                                                    maskChar={null}
                                                    value={businessPhone}
                                                />
                                                {businessPhone && (
                                                    <CopyToClipboard
                                                        text={businessPhone}
                                                        onCopy={() => {
                                                            setCopiedField('Business Phone Number')
                                                            setTimeout(() => {
                                                                setCopiedField(emptyString)
                                                            }, timeOutForAlertPrompt)
                                                        }}
                                                    >
                                                        <span
                                                            className={businessPhone ? 'pointer' : 'pe-none'}
                                                        >
                                                            {copiedField !== 'Business Phone Number' ? (
                                                                <img
                                                                    width='23'
                                                                    height='23'
                                                                    src={Icons.Right}
                                                                    className='mt-1 mb-1 mr-2'
                                                                />
                                                            ) : (
                                                                <img
                                                                    width='23'
                                                                    height='23'
                                                                    src={Images.checkMarkIcon}
                                                                    className='mt-1 mb-1 mr-2'
                                                                />
                                                            )}
                                                        </span>
                                                    </CopyToClipboard>
                                                )}
                        </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div className={'form-group'}>
                                            <Label className='f-14'>Expiration Date</Label>
                                            {getField({
                                                key: 'Expiration Date',
                                                value: getFormattedDateForVarianceData(expirationDate),
                                            })}
                                        </div>
                                    </div>
                                </div>
								<Row>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Label className='f-14'>Trade Name</Form.Label>
											{getField({
												key: 'Trade Name',
												value: tradeName,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Label className='f-14'>LOA Issue Date</Form.Label>
											{getField({
												key: 'Loa Issue Date',
												value: getFormattedDateForVarianceData(loaIssueDate),
											})}
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Label className='f-14'>
												LOA Expiration Date
											</Form.Label>
											{getField({
												key: 'Loa Expiration Date',
												value:
													getFormattedDateForVarianceData(loaExpirationDate),
											})}
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col md={12}>
										<Form.Group classname={'form-group'}>
											<Form.Label className='f-14'>Premises Address</Form.Label>
										</Form.Group>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>Street Address 1</Form.Text>
											{getField({
												key: 'Premises Street Address 1',
												value: premiseStreet,
												shouldTrim: false,
											})}
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>City</Form.Text>
											{getField({
												key: 'Premises City',
												value: premiseCity,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>State</Form.Text>
											{getField({
												key: 'Premises State',
												value: premiseState,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>Zip Code</Form.Text>
											{getField({
												key: 'Premises Zip Code',
												value: premiseZipCode,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col md={12}>
										<Form.Group classname={'form-group'}>
											<Form.Label className='f-14'>Mailing Address</Form.Label>
										</Form.Group>
									</Col>
									<Col md={12}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>Street Address 1</Form.Text>
											{getField({
												key: 'Mailing Street Address 1',
												value: mailingStreet,
												shouldTrim: false,
											})}
										</Form.Group>
									</Col>
								</Row>
								<Row>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>City</Form.Text>
											{getField({
												key: 'Mailing City',
												value: mailingCity,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>State</Form.Text>
											{getField({
												key: 'Mailing State',
												value: mailingState,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
									<Col md={6}>
										<Form.Group classname={'form-group'}>
											<Form.Text className='f-14'>Zip Code</Form.Text>
											{getField({
												key: 'Mailing Zip Code',
												value: mailingZipCode,
												shouldTrim: true,
											})}
										</Form.Group>
									</Col>
								</Row>
							</>
						</div>
					</>
				)}
			</BusyIndicator>
		</Modal>
	)
}
export default VarianceDataModal
